export const sokhna = {
  landmarks: [
    "بوابات العين السخنة",
    "بورتو السخنة",
    "طريق الجلالة",
    "طريق القطامية السخنة",
    "كارتة السخنة",
    "الزعفرانة",
    "طريق السويس السخنة"
  ],
  title: "ونش انقاذ طريق السخنة | خدمة سريعة لطريق القطامية والجلالة",
  metaDescription: "ونش انقاذ سيارات على طريق العين السخنة، الجلالة، وطريق القطامية. نرسل أسرع أوناش السطحة لإنقاذك في حالات طوارئ الطرق السريعة على مدار 24 ساعة.",
  intro: `طريق العين السخنة وطريق الجلالة الجديد يمثلان شرياناً حيوياً للسفر والسياحة طوال العام. ونظراً لطبيعة الطريق السريعة والمنحدرات القوية في منطقة الجلالة، فإن حدوث أي عطل بالسيارة يتطلب تدخلاً عاجلاً وحاسماً من خدمة إنقاذ محترفة.
  نحن في ونش انقاذ طريق السخنة متواجدون بشكل استراتيجي بالقرب من بوابات السخنة وكارتة القطامية لضمان الاستجابة الفورية. نستخدم أوناشاً هيدروليكية ذات قدرة سحب وتثبيت عالية، مصممة خصيصاً لتحمل ضغوط الطرق السريعة والمنحدرات لنقل سيارتك بأمان تام إلى وجهتك.`,
  highlights: [
    "تغطية لطريق القطامية السخنة وطريق الجلالة الجديد والزعفرانة",
    "أوناش سطحة قوية مزودة بأنظمة فرملة مضاعفة تناسب الطرق الجبلية",
    "نقل آمن للسيارات المعطلة من السخنة إلى القاهرة بأسعار تنافسية",
    "استجابة فورية لحالات الطوارئ الليلية وتوفير الدعم الميكانيكي السريع"
  ],
  safetyTips: [
    "على طريق الجلالة أو السخنة، في حالة حدوث عطل مفاجئ، استخدم حارة الطوارئ اليمنى فوراً لتفادي السيارات المسرعة.",
    "قم بتشغيل أنوار الانتظار الرباعية (الفلشر) واستخدم مثلث الأمان العاكس خلف السيارة بمسافة لا تقل عن 100 متر.",
    "في حال تعطلت في منطقة جبلية، أرسل موقعك بدقة (Location) ليتمكن فريقنا من الوصول إليك بسهولة."
  ],
  faqs: [
    {
      q: "هل يمكن لونش الإنقاذ الوصول إليّ في طريق الجلالة ذو المنحدرات؟",
      a: "نعم، أوناشنا مجهزة خصيصاً للتعامل مع المرتفعات والمنحدرات القوية في طريق الجلالة بأمان واحترافية عالية."
    },
    {
      q: "هل تقومون بنقل السيارات المعطلة من بورتو السخنة إلى القاهرة؟",
      a: "نعم، نوفر خدمة النقل الآمن للسيارات من أي مكان بالعين السخنة أو الزعفرانة وإيصالها إلى أي توكيل أو مركز صيانة بالقاهرة."
    },
    {
      q: "كم يستغرق وصول الونش إذا كنت متواجداً عند كارتة السخنة؟",
      a: "نظراً لتمركزنا بالقرب من الكارتة والطرق الرئيسية، يمكننا الوصول إليك في غضون 10 إلى 20 دقيقة."
    },
    {
      q: "سيارتي تعرضت لحادث لا قدر الله على طريق السخنة، هل يمكنكم التعامل مع الموقف؟",
      a: "نعم، فرقنا مزودة بمعدات لرفع سيارات الحوادث بعناية لتقليل الأضرار أثناء عملية النقل من الطريق السريع."
    }
  ],
  seoText: `
    <h2>أسرع استجابة لطوارئ السيارات على طريق العين السخنة</h2>
    <p>السفر على الطرق السريعة مثل طريق القطامية السخنة أو طريق الجلالة يتطلب الشعور بالأمان. نحن نوفر هذا الأمان عبر خدمة ونش انقاذ طريق السخنة، حيث نمتلك أسطولاً מجهزاً للتعامل مع كافة الظروف الجوية والطبيعة الجبلية للمنطقة، لنكون دائماً جاهزين لإنقاذك في أي وقت من اليوم.</p>

    <h3>تأمين سيارتك أثناء السفر الطويل</h3>
    <p>تختلف أوناش الطرق السريعة عن تلك العاملة داخل المدن. نحن نستخدم أوناش السطحة (Flatbed) التي ترفع السيارة بالكامل وتثبتها بواسطة أحزمة ربط قوية (Tie-downs) مخصصة للإطارات الأربعة. هذا التجهيز يمنع أي اهتزاز أثناء النقل لمسافات طويلة، مما يضمن وصول السيارة إلى القاهرة بحالتها الأصلية دون أضرار.</p>

    <h3>شبكة متصلة من السخنة وحتى القاهرة</h3>
    <p>إذا كانت وجهتك إلى القاهرة وتعطلت في منتصف طريق القطامية، فإننا نوفر الدعم المتواصل. وعند اقترابك من القاهرة، ستجد دعمنا يمتد عبر <a href="/areas/القطامية">ونش انقاذ القطامية</a> و <a href="/areas/التجمع الخامس">ونش انقاذ التجمع الخامس</a>، لضمان تغطية متكاملة لرحلتك من البداية وحتى وصولك بالسلامة.</p>
    <p>احفظ رقمنا قبل الانطلاق إلى السخنة لتنعم برحلة خالية من القلق والتوتر.</p>
  `
};
